import { PO_STATUS, ORDER_STATUS, PAYMENT_STATUS } from "@/lib/format";

export const PoBadge = ({ status, className = "" }) => {
  const s = PO_STATUS[status] || PO_STATUS.coming_soon;
  return (
    <span data-testid={`po-badge-${status}`} className={`inline-flex items-center gap-1 text-[10.5px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-md border ${s.cls} ${className}`}>
      {status === "closing_soon" && <span className="h-1.5 w-1.5 rounded-full bg-white animate-pulse" />}
      {s.label}
    </span>
  );
};

export const Pill = ({ children, cls = "", testid }) => (
  <span data-testid={testid} className={`inline-flex items-center text-[10.5px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-md ${cls}`}>
    {children}
  </span>
);

export const DemoBadge = () => <Pill cls="bg-fuchsia-600 text-white" testid="demo-badge">Demo</Pill>;
export const CondBadges = ({ p }) => (
  <>
    {p.condition === "new" && <Pill cls="bg-emerald-600 text-white" testid="cond-new">NEW</Pill>}
    {p.condition === "preowned" && <Pill cls="bg-neutral-700 text-white" testid="cond-preowned">PRE-OWNED</Pill>}
    {p.ownership === "consignment" && <Pill cls="bg-[var(--bk-blue)] text-white" testid="cond-consignment">CONSIGNMENT</Pill>}
  </>
);

export const OrderStatusBadge = ({ status }) => {
  const s = ORDER_STATUS[status] || { label: status, cls: "bg-neutral-100" };
  return <span className={`inline-flex text-xs font-semibold px-2 py-1 rounded-md whitespace-nowrap ${s.cls}`}>{s.label}</span>;
};

export const PaymentBadge = ({ status }) => {
  const s = PAYMENT_STATUS[status] || { label: status, cls: "bg-neutral-100" };
  return <span className={`inline-flex text-xs font-semibold px-2 py-1 rounded-md whitespace-nowrap ${s.cls}`}>{s.label}</span>;
};
